import styled from "styled-components";
import { useState,useEffect } from 'react'
import Card from '../../juegos/card.jsx'
import CheckIcon from '@mui/icons-material/Check';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { solicitudesEstado } from '../../../redux/actions/solicitudActions.js';
import { useDispatch } from 'react-redux';
import api from '../../../axios.js'
import AccountCircle from '@mui/icons-material/AccountCircle';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import mando from "../../../imgs/mando.svg"
import TuneIcon from '@mui/icons-material/Tune';


const Container=styled.div`
	display:flex;
	align-items:center;
	height:220px;
	width:450px;
	background-color:#1F1E1E;
	border-radius:10px 21px 21px 10px;
	transition: all 200ms;
 `;

const ContainerCard=styled.div`
	width:250px;
	height:180px;
	margin:10px

 `;

const ContainerData=styled.div`
	display:flex;
	flex-direction:column;
	justify-content: space-evenly;
	align-items:center;
	height:100%;
	width:100%;

	
 `;
const ContainerId=styled.div`
	font-size:11px;
	color:#27B0FE;
	display:none
 `;
const ContainerPrecio=styled.div`
	font-size:13px;	
 `;

const ContainerUsuarioNombre=styled.div`
	height:10%;
	display:flex;
	justify-content:center;
	align-items:center;
	margin:10px;
	font-size:13px
`;

const ContainerCorreo=styled.div`
	font-size:13px;
	display:flex;
	align-items:center
`;

const ContainerDesicion=styled.div`
	width:7%;
	height:100%;
`;

const ContainerAceptada=styled.div`
	width:25px;
	height:100%;
	display:flex;
	justify-content:center;
	align-items:center;
	writing-mode: vertical-lr;
	background-color:#032C01;
	border-radius:0px 15px 15px 0px;
    
`;

const ContainerRechazada=styled.div`
	width:25px;
	height:100%;
	display:flex;
	justify-content:center;
	align-items:center;
	writing-mode: vertical-lr;
	background-color:#470707;
	border-radius:0px 15px 15px 0px;
    
`;

const ContainerFechaAcetado=styled.div`
	font-size:11px;
	display:flex;	
`;

const DetalleAceptado=styled.div`
	display:flex;
	flex-direction:column
`;

const Accept=styled.div`
	display:flex;
	align-items:center;
	justify-content:center;
	border-radius:0px 15px 0px 0px;
	background-color:#032C01;
	height:50%;
`;

const Decline=styled.div`
	display:flex;
	align-items:center;
	justify-content:center;
	border-radius:0px 0px 15px 0px;
	background-color:#470707;
	height:50%;
`;
const ContainerPrecioPais=styled.div`
	display:flex;
	justify-content:space-around;
	align-items:center;
	width:100%
`;



 export default function RowSolicitud(props){
 	let { solicitud } = props;
 	let [juego,setJuego] = useState([]);
 	let [selected,setSelected] = useState({status:false,color:"red"});
 	let dispatch=useDispatch();
 	let moneda="Dolares";

 	useEffect(()=>{
 		api.get(`/juego/?id=${solicitud.Reventum.JuegoId}` )
 		.then(rsp=>rsp.data)
 		.then(data=>setJuego(data))
 	},[solicitud])
 	
 	let aceptar=async(e)=>{
 		dispatch(solicitudesEstado(1));
 		setSelected({status:true,color:"green"});
 		await new Promise(resolve => setTimeout(resolve, 300));
 		
 		if(window.confirm( `desea ACEPTAR la solicitud de ${solicitud.User.name} con id ${solicitud.id}`)){
 			try{
 				await api.post(`/solicitud/valida?id=${solicitud.id}`);	
 				alert("solicitud aceptada");	
 				dispatch(solicitudesEstado(0));

 			}catch(err){ console.error(err);alert(err.response.data) };
 		};
 		setSelected({status:false,color:"red"});
 		dispatch(solicitudesEstado(0)); 

 	}

 	let rechazar=async(e)=>{
 		dispatch(solicitudesEstado(1));
 		setSelected({status:true,color:"red"});
 		await new Promise(resolve => setTimeout(resolve,300));
 		
 		if(window.confirm( `desea RECHAZAR la solicitud de ${solicitud.User.name}con id ${solicitud.id}`)){
 			try{
 				await api.post(`/solicitud/rechasa?id=${solicitud.id}`);
 				alert("solicitud rechazada");
 				dispatch(solicitudesEstado(0));
 			}catch(err) {console.error(err);alert(err.response.data)};
 			

 		};
 		setSelected({status:false,color:"red"});
 		dispatch(solicitudesEstado(0));
 	};

 	switch(solicitud.pais){
 	case "precio_peru":
 		moneda="Soles"
 		break
 	case "precio_bolivia":
 		moneda="Bolivianos"
 		break
 	case "precio_argentina":
 		moneda="Pesos"
 		break
 	case "precio_mexico":
 		moneda="Pesos"
 		break
 	case "precio_colombia":
 		moneda="Pesos"
 		break
 	case "precio_chile":
 		moneda="pesos"
 		break
 	case "precio_uruguay":
 		moneda="Pesos"
 		break
 	default:
 		moneda="Dolares"
 	}


 	return(
 		<Container style={{scale:selected.status?"1.01":"none", backgroundColor:selected.status?"#323030":"#1F1E1E",border:selected.status?`3px solid ${selected.color}`:"none"}}>

 			{juego?<ContainerCard><Card consola={juego.consola} poster={juego.poster}/></ContainerCard>:null}

 				<ContainerData>
 					<ContainerId>id: {solicitud.id}</ContainerId>
 					 						
 						<ContainerUsuarioNombre>
 								 <AccountCircle style={{ fontSize: 35,marginRight:"15px"}}/>
 								 <div>{solicitud.User.name} </div>
 						</ContainerUsuarioNombre>

 						{solicitud.aceptada===true? 
 									<ContainerFechaAcetado style={{color:"green"}}>
 										<div><CalendarMonthIcon style={{ fontSize: 35,marginRight:"8px"}}/></div>
 										<DetalleAceptado>
 											<b>fecha aceptado : </b>
 										 	<span>{new Date(solicitud.updatedAt).toLocaleDateString()} {new Date(solicitud.updatedAt).toLocaleTimeString()}</span>
 										</DetalleAceptado>	
 									</ContainerFechaAcetado>
 						:solicitud.aceptada===false?
 									<ContainerFechaAcetado style={{color:"red"}} >
 										<div><CalendarMonthIcon style={{ fontSize: 35,marginRight:"8px"}}/></div>
 										<DetalleAceptado>
 											<b>fecha rechazo : </b> 
 											<span>{new Date(solicitud.updatedAt).toLocaleDateString()} {new Date(solicitud.updatedAt).toLocaleTimeString()}</span>
 										</DetalleAceptado>
 									</ContainerFechaAcetado>:
 									<ContainerFechaAcetado  >
 										<div><CalendarMonthIcon style={{ fontSize: 35,marginRight:"8px"}}/></div>
 										<DetalleAceptado>
 											<b>fecha registro : </b> 
 											<span>{new Date(solicitud.updatedAt).toLocaleDateString()} {new Date(solicitud.updatedAt).toLocaleTimeString()}</span>
 										</DetalleAceptado>
 									</ContainerFechaAcetado>}
 					
 					<ContainerCorreo> <img src={mando} style={{marginRight:"8px"}} alt="imagen de mando" />{solicitud.Reventum.correo}</ContainerCorreo>
 					<ContainerCorreo><TuneIcon style={{ fontSize: 15,marginRight:"5px"}}/> tipo cuenta : {solicitud.tipo_cuenta===1?"principal":"secundaria"}</ContainerCorreo>
 					<ContainerPrecioPais>
 						<ContainerPrecio>
	 						<div><b>pais : </b>{solicitud.pais.split("_")[1]} </div>
	 					</ContainerPrecio> 
	 					<ContainerPrecio> 
	 						<div><b>actual:</b> {solicitud.Reventum[solicitud.pais]+" "+moneda}</div>
	 						<div><b>precio:</b> {solicitud.nuevo_precio+" "+moneda}</div>
	 					</ContainerPrecio>
 					</ContainerPrecioPais> 					
 				</ContainerData>
 				{solicitud.aceptada?<ContainerAceptada><b>Aceptada</b></ContainerAceptada>:solicitud.aceptada===false?<ContainerRechazada><b>Rechazada</b></ContainerRechazada>:
 					<ContainerDesicion>
 						<Accept onClick={aceptar}><CheckIcon  style={{color:"green"}} /></Accept>
 						<Decline onClick={rechazar}><DeleteOutlineIcon style={{color:"#BB0E0E"}}/> </Decline>
 					</ContainerDesicion>}
 		</Container>


 		)
 }